import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { TenantSettings } from '@org/interfaces';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TenantSettingsService {
    private apiUrl = `${environment.apiUrl}/api/tenants`;

  constructor(private http: HttpClient, private authService: AuthService) {}

  getTenantSettings(): Observable<TenantSettings> {
    return this.http.get<TenantSettings>(`${this.apiUrl}/settings`)
    .pipe(
        catchError(this.handleError)
      );
  }

  updateTenantSettings(settings: Partial<TenantSettings>): Observable<TenantSettings> {
    return this.http.put<TenantSettings>(`${this.apiUrl}/settings`, settings)
    .pipe(
        catchError(this.handleError)
      );
  }

   // Handle errors
   private handleError(error: any) {
    console.error('An error occurred:', error);
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }
}